"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventType;
(function (EventType) {
    EventType["PUBLISH"] = "GAIA::publish";
    EventType["CAROUSEL"] = "GAIA::carousel";
})(EventType = exports.EventType || (exports.EventType = {}));
(function (EventType) {
    function withChannelId(eventType, channelId) {
        return channelId ? eventType + "::" + channelId : eventType;
    }
    EventType.withChannelId = withChannelId;
})(EventType = exports.EventType || (exports.EventType = {}));
